import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { LanguageProvider } from './contexts/LanguageContext';
import Dashboard from './pages/Dashboard';
import Admin from './pages/Admin';
import UserView from './pages/UserView';
import TimerEmbed from './pages/TimerEmbed';
import ControlPanel from './pages/ControlPanel';
import CompanyLogin from './pages/CompanyLogin';
import CompanyManagement from './pages/CompanyManagement';
import DeviceLogin from './pages/DeviceLogin';
import DeviceDisplay from './pages/DeviceDisplay';
import DeviceManagement from './pages/DeviceManagement';
import AccountManagement from './pages/AccountManagement';
import DataBackup from './pages/DataBackup';
import DataQuery from './pages/DataQuery';
import DashboardBuilder from './pages/DashboardBuilder';
import DataScreen from './pages/DataScreen';
import DataCalculation from './pages/DataCalculation';
import LanguageManagement from './pages/LanguageManagement';
import SlideshowManagement from './pages/SlideshowManagement';
import AnimationManagement from './pages/AnimationManagement';
import WebhookLogs from './pages/WebhookLogs';
import DisplayPage from './pages/DisplayPage';
import DisplayApiLogs from './pages/DisplayApiLogs';
import Analytics from './pages/Analytics';
import GlobalSettings from './pages/GlobalSettings';
import './App.css';

function App() {
  return (
    <LanguageProvider>
      <Router>
        <div className="App">
          <Routes>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/user/:userId" element={<UserView />} />
          <Route path="/timer/:timerId" element={<TimerEmbed fullVersion={false} />} />
          <Route path="/timer/:timerId/full" element={<TimerEmbed fullVersion={true} />} />
          <Route path="/timer/:timerId/full2" element={<TimerEmbed fullVersion2={true} />} />
          <Route path="/timer/:timerId/display" element={<TimerEmbed displayVersion={true} />} />
          <Route path="/control/:timerId" element={<ControlPanel />} />

          {/* Company and Device routes */}
          <Route path="/companies" element={<CompanyManagement />} />
          <Route path="/company-login" element={<CompanyLogin />} />
          <Route path="/device-login" element={<DeviceLogin />} />
          <Route path="/device/:deviceId" element={<DeviceDisplay />} />
          <Route path="/devices" element={<DeviceManagement />} />

          {/* Account management routes */}
          <Route path="/accounts" element={<AccountManagement />} />

          {/* Data backup routes */}
          <Route path="/data-backup" element={<DataBackup />} />
          <Route path="/data-backup/:accountId" element={<DataBackup />} />

          {/* Data query routes */}
          <Route path="/data-query" element={<DataQuery />} />
          <Route path="/data-query/:accountId" element={<DataQuery />} />

          {/* Dashboard builder routes */}
          <Route path="/dashboard-builder" element={<DashboardBuilder />} />
          <Route path="/dashboard-builder/:accountId" element={<DashboardBuilder />} />

          {/* Data screen routes */}
          <Route path="/data-screen" element={<DataScreen />} />
          <Route path="/data-screen/:accountId" element={<DataScreen />} />

          {/* Data calculation routes */}
          <Route path="/data-calculation" element={<DataCalculation />} />
          <Route path="/data-calculation/:accountId" element={<DataCalculation />} />

          {/* Language management route */}
          <Route path="/languages" element={<LanguageManagement />} />

          {/* Slideshow management route */}
          <Route path="/slideshows" element={<SlideshowManagement />} />

          {/* Animation management route */}
          <Route path="/animations" element={<AnimationManagement />} />

          {/* Webhook logs route */}
          <Route path="/webhook-logs" element={<WebhookLogs />} />

          {/* Display API logs route */}
          <Route path="/display-api-logs" element={<DisplayApiLogs />} />

          {/* Analytics route */}
          <Route path="/analytics" element={<Analytics />} />

          {/* Global settings route */}
          <Route path="/settings" element={<GlobalSettings />} />

          {/* Display page route */}
          <Route path="/display/:displayId" element={<DisplayPage />} />

          {/* Legacy routes */}
          <Route path="/embed/simple/:timerId" element={<TimerEmbed fullVersion={false} />} />
          <Route path="/embed/full/:timerId" element={<TimerEmbed fullVersion={true} />} />
          <Route path="/embed/full2/:timerId" element={<TimerEmbed fullVersion2={true} />} />
        </Routes>
      </div>
    </Router>
    </LanguageProvider>
  );
}

export default App;
